import $ from 'jquery'
import Swal from 'sweetalert2'

export const debounce = (fn, threshold) => {
    var timeout
    threshold = threshold || 100
    return function debounced() {
        clearTimeout(timeout)
        var args = arguments
        var _this = this
        function delayed() {
            fn.apply(_this, args)
        }
        timeout = setTimeout(delayed, threshold)
    }
}

export const getTextNodesIn = (node) => {
    let textNodes = []
    let nodeStack = [node]

    while (nodeStack.length > 0) {
        const currentNode = nodeStack.pop()
        if (currentNode.nodeType === Node.TEXT_NODE) {
            textNodes.push(currentNode)
        } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
            const children = currentNode.childNodes
            for (let i = children.length - 1; i >= 0; i--) {
                nodeStack.push(children[i])
            }
        }
    }

    return textNodes
        .map((node) => node.textContent.trim())
        .join('')
        .replace(/\s+/g, ' ')
}

const alert = Swal.mixin({})

export const Alert = (success = true, message = '', duration = 6000) => {
    let type
    if (typeof success === 'boolean') {
        type = success ? 'success' : 'error'
    } else {
        type = success
    }

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        customClass: {
            popup: 'vn-toast-popup',
            container: 'vn-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
            toast.addEventListener('click', Swal.close)
        },
    })
}


